import { scCoreModule } from '../core/core.module';
import { scFilterModule } from '../filter/filter.module';
import { scFactsModule } from '../facts/facts.module';
import { scStatModule } from '../stat/stat.module';
import { scSharedModule } from '../shared/shared.module';
import { RootCtrl } from './root';
import { SidebarComponent } from './sidebar.component';
import { scViewModule } from '../view/view.module';
import { SidebarToggleComponent } from './sidebar-toggle.component';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';
import { scAdminModule } from '../admin/admin.module';

export const scLayoutModule = 'sc-layout';

angular.module(scLayoutModule, [
  scFactsModule,
  scStatModule,
  scCoreModule,
  scFilterModule,
  scSharedModule,
  scViewModule,
  scAdminModule,
])
  .controller('RootCtrl', RootCtrl)
  .directive('scSidebar', SidebarComponent)
  .component('scSidebarToggle', SidebarToggleComponent)
  .component('scHeader', HeaderComponent)
  .component('scFooter', FooterComponent)
;



// WEBPACK FOOTER //
// ./src/layout/layout.module.js